import { DateTime, Settings } from 'luxon';

Settings.defaultZone = 'Europe/Vienna';

export function getDateFromIsoStringWithCetFallback(dateString) {
    return DateTime.fromISO(dateString,{
        zone: Settings.defaultZone
    }).toJSDate();
}

export function getDateFromProcessMessage(dateString) {
    let d = getDateFromIsoStringWithCetFallback(dateString)
    if(isDateValid(d))
        return d;

    d = DateTime.fromFormat(dateString,"yyyy-MM-ddZZ");
    if(d.isValid)
        return d.toJSDate()

    return null;
}

export function formatDateAsIso(date) {
        return DateTime.fromJSDate(date).toFormat("yyyy-MM-dd")
}

/**
 * legacy time related formating tools - use DateUtils.js further on
 * handling Date JS objects with no regards to time zone (using default system time zone)
 */

Number.prototype.pad = function (size) {
    let s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

/// date: Date
export function isDateValid(date) {
    try {
        // !valid => getTime === NaN
        // https://www.geeksforgeeks.org/how-to-check-a-date-is-valid-or-not-using-javascript/
        return date.getTime() === date.getTime()
    } catch (e) {
        return false
    }
}

/// dateToFormat: Date
export function formatDateTime(dateToFormat) {
    if(!isDateValid(dateToFormat))
        return "";

    const date = dateToFormat.getDate().pad(2) + '.' + (dateToFormat.getMonth() + 1).pad(2) + '.' + dateToFormat.getFullYear();
    const time = dateToFormat.getHours().pad(2) + ":" + dateToFormat.getMinutes().pad(2) + ":" + dateToFormat.getSeconds().pad(2);
    return time + ' ' + date;
}

/// dateToFormat: Date
export function formatDate(dateToFormat) {
    if(!isDateValid(dateToFormat))
        return "";

    return dateToFormat.getDate().pad(2) + '.' + (dateToFormat.getMonth() + 1).pad(2) + '.' + dateToFormat.getFullYear();
}

/// [Date, Date] -> [[Date, Date],[Date, Date]] <JSDate>
export function extractDateRangesFromDateArray(inputDateArray) {
  const ranges = [];

  // sort ASC
  inputDateArray.sort( (a,b)=>a.getTime()-b.getTime());

  let start;
  let last;
  for(const currentDate of inputDateArray) {
    if(!start) {
      // no sequence open
      start = currentDate;
      continue;
    }

    // gap to long?
    if(!last && (currentDate.getTime() - start.getTime())/(1000 * 60 * 60 * 24) > 1
      || last && (currentDate.getTime() - last.getTime())/(1000 * 60 * 60 * 24) > 1){
      // close old entry
      if(last)
        ranges.push([start, last])
      else
        ranges.push([start, start])

      // open new entry
      start = currentDate;
      last = null;
      continue;
    }

    // should be one day apart
    last=currentDate;
  }

  // close open
  if(last)
    ranges.push([start, last])
  else
    ranges.push([start, start])

  return ranges;
} // extractDateRangesFromDateArray

export default {
  isDateValid,
  formatDate,
  formatDateTime,
  extractDateRangesFromDateArray, formatDateAsIso,
};
